import React from 'react';
import CasperHero from "./component/CasperHero";
import MessageBox from "./component/MessageBox";
import "./App.css";

function App() {
  let _$_appMessage = ''
  return (
    <div className="App">
      <div className="casper-wrapper">
        <CasperHero />
      </div>

      <div className="message-wrapper">
        <MessageBox />
      </div>
    </div>
  );
}

export default App;
